import { render, staticRenderFns } from "./ProposalActions.vue?vue&type=template&id=3dd49cea&scoped=true&"
import script from "./ProposalActions.vue?vue&type=script&lang=js&"
export * from "./ProposalActions.vue?vue&type=script&lang=js&"
import style0 from "./ProposalActions.vue?vue&type=style&index=0&id=3dd49cea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd49cea",
  null
  
)

export default component.exports